// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"4d7eb777","41":"8c083561","199":"3a197482","396":"ce962af4","437":"96ecfc98","453":"abed344b","628":"ea0d353e","839":"bc3948b1","882":"3dedbc53","926":"678f54e7"}[chunkId] + ".chunk.js";
};